import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Card, Col } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** UTILS || SLICE */
import { setFormAppointment } from 'app/slice/appointment.slice'
import { resetModal, showModal } from 'app/slice/modal.slice'
import { KEY_STORAGE } from 'constants/common'

/** API */
import AboutUs from 'api/admin/clinic-manage/about.api'
import AppointmentApi from 'api/counter/appointment.api'
import HomeApi from 'api/home/home.api'
import BranchApi from 'api/setting/branch-service-points/branch.api'
import { FormAppointment } from 'features/counter/appointment/form-appointment'

/** COMPONENT */
import { swalDelete } from 'component/Alert/Swal'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import { AppointmentDisplayDayInterface, AppointmentDisplayWeekInterface } from 'features/counter/appointment/appointment-interface'
import DisplayDay from 'features/counter/appointment/display-day'
import DisplayMonth from 'features/counter/appointment/display-month'
import DisplayWeek from 'features/counter/appointment/display-week'
import HeadAppointment, { DateInterface, ViewDisplayType } from 'features/counter/appointment/head-appointment'

import Loading from 'component/Loading'
import { PACKAGE_ADDONS } from 'constants/package'
import DisplayOverall from 'features/counter/appointment/display-overall'
import ViewHistory from 'features/counter/appointment/view-history'
import { TIME_APPOINTMENT } from 'features/setting/branch-service-point/branch/form-branch'
import { checkAddons, getBranch, getSecureItem } from 'utils/app.utils'
import useWindowSize from 'utils/useWindowSize'
import AppointmentApp from './appointment-app'
import AppointmentScheduleShare from './appointment-schedule-share'
import { DivNoneData } from './style'






export default function DoctorAppointment() {
  const location = useLocation()
  const [width, height] = useWindowSize()
  const fromAppointmentRef = useRef<HTMLDivElement>(null)
  const sizeSectionAppointment = useFormatSizeAppointment();

  //** New */
  const [viewDisplay, setViewDisplay] = useState<ViewDisplayType>('DATE')
  const dateNow = moment().format('YYYY-MM-DD-ddd').split('-')
  const [filterDate, setFilterDate] = useState<DateInterface>({ year: Number(dateNow[0]), month: Number(dateNow[1]), date: Number(dateNow[2]), day: String(dateNow[3]) })
  const [filterPatient, setFilterPatient] = useState<number>(0)
  const [filterBranch, setFilterBranch] = useState<any>(getBranch())
  const [filterDoctor, setFilterDoctor] = useState<string>('')
  const [formAppointmentWidth, setFormAppointmentWidth] = useState<number>(0)
  const [reRender, setRerender] = useState(false)

  const [showForm, setShowForm] = useState<boolean>(false)
  const [showListAppointment, setShowListAppointment] = useState<boolean>(false)
  const [appointmentId, setAppointmentId] = useState<number>()
  const [timeRange, setTimeRange] = useState<string[]>([])
  const [clinicInfo, setClinicInfo] = useState<{ timeIn?: string; timeOut?: string; officeTimes?: any, timeAppointment?: TIME_APPOINTMENT }>({})
  const [clinicDayClose, setClinicDayClose] = useState<string[]>([])
  const [clinicIsClose, setClinicIsClose] = useState(false)

  const [listAppointmentDay, setListAppointmentDay] = useState<AppointmentDisplayDayInterface[]>([])
  const [listAppointmentWeek, setListAppointmentWeek] = useState<AppointmentDisplayWeekInterface[]>([])
  const [listAppointmentMonth, setListAppointmentMonth] = useState<AppointmentDisplayWeekInterface[]>([])

  const [loading, setLoading] = useState<boolean>(true)
  const [editSpecialInfo, setEditSpecialInfo] = useState<boolean>(false)

  const [dataReRender, setDataReRender] = useState<any>({})
  const [doctorWeek, setDoctorWeek] = useState<any>({})

  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()

  const branchId = useMemo(() => getBranch(), [])
  const [branch, setBranch] = useState<any>()

  const [key, setKey] = useState<number>(0)

  const [openShare, setOpenShare] = useState<boolean>(false)
  const [dataShare, setDataShare] = useState<any>()

  const [popApp, setPopApp] = useState<boolean>(false)
  const popAppRef = useRef<HTMLDivElement>(null)

  const [patientIdApp, setPatientIdApp] = useState<any>({})
  const [dataAppAppointment, setDataAppAppointment] = useState<any>([])

  const [doctorId, setDoctorId] = useState<number | undefined>(undefined)

  // Display Pages
  interface DisplayPageInterface {
    displayPageId: number
    pageNumber: number
    pageName: string
    pageNameEn: string
    servicePointCount: number
  }
  const [displayPages, setDisplayPages] = useState<DisplayPageInterface[]>([])
  const displayPagesRef = useRef<DisplayPageInterface[]>([])
  useEffect(() => { displayPagesRef.current = displayPages }, [displayPages])
  const initialLoadDoneRef = useRef<boolean>(false)
  const loadAppointmentRequestIdRef = useRef<number>(0)
  const [selectedPage, setSelectedPage] = useState<number>(0) // 0 = แสดงทั้งหมด

  // Reset selectedPage to 0 (ALL) when form-appointment is opened
  useEffect(() => {
    if (showForm) {
      setSelectedPage(0)
    }
  }, [showForm])

  const loadDisplayPages = async () => {
    try {
      const res = await HomeApi.getDisplayPages()
      if (res.status === 200 && res.data) {
        setDisplayPages(res.data)
      }
    } catch (e) {
      console.error('Failed to load display pages', e)
    }
  }

  useEffect(() => {
    loadDisplayPages()
  }, [filterBranch])

  const loadBranchInfo = () => {
    AboutUs.detailClinic(Number(branchId))
      .then(({ data }) => {
        setBranch(data)
        const newForm = data?.formAppointment ? JSON.parse(data?.formAppointment) : []
        const formAppointment = newForm?.sub[0]?.inputName?.length ? newForm?.sub[0]?.inputName : []
        dispatch(setFormAppointment(formAppointment))
      })
      .catch((e) => { return })
  }

  useEffect(() => {
    loadBranchInfo()
  }, [branchId])

  const loadTimeBranch = useCallback(() => {
    if (filterBranch) {
      BranchApi.findById(filterBranch)
        .then(({ data }) => {
          if (data) {
            let rDayOfWeek: string[] = []
            _.forEach(data.officeTimes, (oft) => {
              if (oft.officeStatus === 'CLOSE') rDayOfWeek = [...rDayOfWeek, oft.dayOfWeek.toUpperCase()]
            })
            setClinicDayClose(rDayOfWeek)
            setClinicInfo(data)
          }
        })
        .catch(() => {
          return
        })
    }
  }, [filterBranch])

  const handleLoadTimeBranch = useCallback(() => {
    setClinicIsClose(false)
    const defaultRange = ['9.00', '10.00', '11.00', '12.00', '13.00', '14.00', '15.00', '16.00', '17.00', '18.00']
    if (!_.isEmpty(clinicInfo)) {
      let objTime: { timeIn?: string; timeOut?: string; officeStatus?: string } = {}
      if (viewDisplay === 'DATE') {
        const daySelect = moment(`${filterDate.year}-${String(filterDate.month).padStart(2, '0')}-${String(filterDate.date).padStart(2, '0')}`, 'YYYY-MM-DD')
        objTime = _.find(clinicInfo?.officeTimes, (time) => time?.dayOfWeek === moment(daySelect).locale('en').format('ddd'))
      } else objTime = clinicInfo

      if (objTime?.officeStatus === 'CLOSE') setClinicIsClose(true)

      let start: any = moment(objTime?.timeIn, 'HH:mm')
      let end: any = moment(objTime?.timeOut, 'HH:mm')
      if (parseInt(start.format('mm')) > 0) start = moment(objTime?.timeIn, 'HH:mm').startOf('hour')
      if (parseInt(end.format('mm')) > 0) end = moment(objTime?.timeOut, 'HH:mm').endOf('hour').add(1, 'minute')

      const timeEnd = parseInt(end.format('HH')) === 0 ? 24 : parseInt(end.format('HH'))
      const arrayTimeRanges: any = []
      for (let index = parseInt(start.format('HH')); index <= timeEnd; index++) {
        arrayTimeRanges.push(`${String(index).padStart(2, '0')}:00`)
      }

      if (!_.isEmpty(arrayTimeRanges)) setTimeRange(arrayTimeRanges)
      else setTimeRange(defaultRange)
    } else setTimeRange(defaultRange)
  }, [clinicInfo, viewDisplay, filterDate])

  const loadAppointment = useCallback(async (inputDate?: any) => {
    const requestId = ++loadAppointmentRequestIdRef.current
    const isStale = () => requestId !== loadAppointmentRequestIdRef.current

    const wasInitialLoadDone = initialLoadDoneRef.current
    setLoading(true)
    setListAppointmentWeek([])
    setListAppointmentMonth([])
    setListAppointmentDay([])
    const { date, month, year }: any = inputDate || filterDate
    let condition: any = {}
    condition = { ...condition, branchId: filterBranch }
    condition = { ...condition, date: `${year}-${String(month).padStart(2, '0')}-${String(date).padStart(2, '0')}` }
    condition = { ...condition, doctorId: filterDoctor !== '' ? filterDoctor : '0' }
    if (condition.doctorId === '0') {
      await loadDataApp()
      if (!isStale() && wasInitialLoadDone) setLoading(false)
      return
    }
    initialLoadDoneRef.current = true
    if (filterPatient !== 0) condition = { ...condition, patientId: filterPatient }

    const isNumeric = (value: any) => /^\d+$/.test(value)
    const compareServicePoint = (sp1: any, sp2: any) => {
      if (sp1 === null) return 1
      if (sp2 === null) return -1
      if (isNumeric(sp1) && isNumeric(sp2)) return Number(sp1) - Number(sp2)
      if (isNumeric(sp1)) return -1
      if (isNumeric(sp2)) return 1
      return sp1.localeCompare(sp2, 'th')
    }

    const display = inputDate?.display || viewDisplay
    if (display === 'WEEK') {
      await AppointmentApi.displayWeek(condition)
        .then(({ data }) => {
          if (isStale()) return
          if (data) setListAppointmentWeek(data)
        })
        .finally(() => { if (!isStale()) setLoading(false) })
    } else if (display === 'MONTH' || display === 'OVERALL') {
      await AppointmentApi.displayMonth(condition)
        .then(({ data }) => {
          if (isStale()) return
          if (data) setListAppointmentMonth(data)
        })
        .finally(() => { if (!isStale()) setLoading(false) })
    } else {
      await AppointmentApi.displayDay(condition)
        .then(({ data }) => {
          if (isStale()) return
          if (data) {
            const lang = i18n.language === 'th' ? 'servicePointName' : 'servicePointNameEn'
            const hasPageLayer = checkAddons(PACKAGE_ADDONS.ADDON_BRANCH_PAGE_LAYER)
            const currentDisplayPages = displayPagesRef.current
            const getPageIndex = (pageNumber: number) => {
              const idx = currentDisplayPages.findIndex((p: any) => p.pageNumber === pageNumber)
              return idx === -1 ? 999 : idx
            }

            const newDataSort = data.slice().sort((a: any, b: any) => {
              if (hasPageLayer && selectedPage === 0 && currentDisplayPages.length > 0) {
                const pageIdxA = getPageIndex(a.displayPage)
                const pageIdxB = getPageIndex(b.displayPage)
                if (pageIdxA !== pageIdxB) return pageIdxA - pageIdxB
              }

              if (hasPageLayer) {
                const sortA = a.servicePointSorting
                const sortB = b.servicePointSorting
                if (typeof sortA === 'number' && typeof sortB === 'number') {
                  if (sortA !== sortB) return sortA - sortB
                } else if (typeof sortA === 'number') {
                  return -1
                } else if (typeof sortB === 'number') {
                  return 1
                }
              }

              const spComparison = compareServicePoint(a[lang], b[lang])
              if (spComparison !== 0) return spComparison
              return a.doctorFullname.localeCompare(b.doctorFullname, 'th')
            })

            setListAppointmentDay(newDataSort || data)
          }
        })
        .finally(() => { if (!isStale()) setLoading(false) })
    }
    if (!isStale()) loadDataApp()
  }, [viewDisplay, filterDate, filterPatient, filterBranch, filterDoctor, reRender, selectedPage, i18n.language])

  useEffect(() => {
    loadAppointment()
  }, [loadAppointment])

  // useMemo(() => {
  //   return loadAppointment()
  // }, [loadAppointment])

  useEffect(() => {
    loadTimeBranch()
  }, [loadTimeBranch])
  useEffect(() => {
    handleLoadTimeBranch()
  }, [handleLoadTimeBranch])

  useEffect(() => {
    const patientState: any = location.state
    if (patientState) {
      dispatch(showModal())
      setShowForm(true)
      loadTimeBranch()
      handleLoadTimeBranch()
    }
  }, [location.state])

  const addAppointment = useCallback(() => {
    if (!showForm) {
      dispatch(showModal())
      setShowForm(true)
    }
  }, [showForm, dispatch])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id: any = params.get('appointmentId');
    const doctorId: any = params.get('doctorId');
    const branchId: any = params.get('branchId');
    const date: any = params.get('date');
    if (id) {
      onEdit(id, false, doctorId, date, branchId)
    }
  }, []);

  const onViewHistory = useCallback(() => {
    dispatch(showModal())
    setShowListAppointment(true)
  }, [dispatch])

  const onEdit = useCallback((id: number, specialInfo: boolean, doctorId?: number, date?: string, branchId?: number) => {
    if (!showForm) {
      dispatch(showModal())
    }
    if (date) {
      const momentDate = moment(date)
      setFilterDate({
        year: momentDate.year(),
        month: momentDate.month() + 1,
        date: momentDate.date(),
        day: momentDate.format('ddd')
      })
    }
    if (branchId) setFilterBranch(branchId)
    setAppointmentId(id)
    setDoctorId(doctorId)
    setShowListAppointment(false)
    setShowForm(true)
    setKey(prev => prev + 1)
    setEditSpecialInfo(specialInfo)
    setPopApp(false)
  }, [showForm, dispatch])

  const onDelete = useCallback((id: number, obj: any) => {
    swalDelete(
      `<p class="mb-0 mx-auto" style="max-width: 325px">${t('APPOINTMENT.ALERT.CONFIRM_DELETE')}</p>`,
      `<p class="text-left mb-0 mx-auto" style="max-width: 306px">${t(`APPOINTMENT.ALERT.CONFIRM_DELETE_`, {
        cnNumber: obj.branchCnNumber ? `${obj.branchCnNumber}` : '',
        patientFullName: obj.patientFullname,
        time: obj.timeStart ? moment(obj.timeStart, 'HH:mm').format('HH:mm') : ''
      })}</p>`,
      (res: any) => {
        if (res) {
          AppointmentApi.remove(id)
            .then((resp) => {
              notiSuccess(t('APPOINTMENT.MESSAGE.SUCCESS.DELETE'))
              loadAppointment()
              setRerender(prev => !prev)
            })
            .catch((e) => notiError(t('APPOINTMENT.MESSAGE.ERROR')))
        }
      },
      { confirmButtonText: t("APPOINTMENT.BUTTON.DEL_APPOINTMENT"), cancelButtonText: t('BUTTON.CANCEL') }
    )
  }, [t, loadAppointment])

  const handleClickShare = useCallback((doctor: any) => {
    setOpenShare(true)
    setDataShare(doctor)
  }, [])

  const viewDisplayData = useMemo(() => {
    if (viewDisplay === 'DATE') return { data: listAppointmentDay, viewDisplay }
    if (viewDisplay === 'WEEK') return { data: listAppointmentWeek, viewDisplay }
    return { data: listAppointmentMonth, viewDisplay }
  }, [viewDisplay, listAppointmentDay, listAppointmentWeek, listAppointmentMonth])

  const filteredListAppointmentDay = useMemo(() => {
    if (selectedPage === 0) return listAppointmentDay
    return listAppointmentDay.filter((item: any) => item.displayPage === selectedPage)
  }, [listAppointmentDay, selectedPage])

  const handleSetDataReRender = useCallback((data: any) => {
    setDataReRender(data)
  }, [])

  const scrollAppointmentTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  useEffect(() => {
    return () => {
      if (scrollAppointmentTimerRef.current) clearTimeout(scrollAppointmentTimerRef.current)
    }
  }, [])

  const handleScrollAppointment = useCallback((appId: number, _index: number) => {
    if (!appId) return
    if (scrollAppointmentTimerRef.current) clearTimeout(scrollAppointmentTimerRef.current)
    scrollAppointmentTimerRef.current = setTimeout(() => {
      scrollAppointmentTimerRef.current = null
      const element: HTMLElement | null = document.querySelector(`[data-value="${appId}"]`)
      const container = document.getElementById('service-slider-container')
      if (!element || !container) return

      const elementRect = element.getBoundingClientRect()
      const containerRect = container.getBoundingClientRect()
      const scrollTop = elementRect.top - containerRect.top + container.scrollTop - (container.clientHeight / 2) + (elementRect.height / 2)
      const scrollLeft = elementRect.left - containerRect.left + container.scrollLeft - (container.clientWidth / 2) + (elementRect.width / 2)

      container.scrollTo({ top: scrollTop, left: scrollLeft, behavior: 'smooth' })
      setDataReRender({})
      setDoctorWeek({})
    }, 500)
  }, [])

  useEffect(() => {
    if (!dataReRender.timeStart) return

    if (viewDisplay === 'WEEK') {
      setDoctorWeek({ doctorId: dataReRender.doctorId, date: dataReRender.date })
      for (let i = 0; i < listAppointmentWeek.length; i++) {
        const item = listAppointmentWeek[i]
        if (item.date !== dataReRender.date) continue
        const matchedDoctor = item.doctors.find((d: any) => d.doctorId === dataReRender.doctorId)
        if (!matchedDoctor) break
        const groupAppointments = matchedDoctor.groupAppointments[dataReRender.timeStart]
        if (Array.isArray(groupAppointments) && groupAppointments.length > 0) {
          handleScrollAppointment(groupAppointments[0].appointmentId, i)
        }
        break
      }
      return
    }

    for (let i = 0; i < listAppointmentDay.length; i++) {
      const item = listAppointmentDay[i]
      if (item.doctorId !== dataReRender.doctorId) continue
      const groupAppointments = item.groupAppointments?.[dataReRender.timeStart]
      if (groupAppointments && groupAppointments.length > 0) {
        handleScrollAppointment(groupAppointments[0].appointmentId, i)
      }
      break
    }
  }, [listAppointmentDay, listAppointmentWeek, dataReRender, viewDisplay, handleScrollAppointment])

  const handleAutoScrollAfterOpenForm = () => {
    const containerScroll: any = document.querySelectorAll('#service-slider-container')
    const currentScroll = containerScroll[0]?.scrollLeft;
    const maxScroll = containerScroll[0]?.scrollWidth - containerScroll[0]?.clientWidth;

    if (showForm && (currentScroll + 50) >= maxScroll) {
      const container = document.getElementById('service-slider-container')
      if (container) {
        container.scrollTo({ left: maxScroll + width, behavior: 'smooth' })
      }
    }
  }

  useEffect(() => {
    if (fromAppointmentRef.current) {
      const element: any = fromAppointmentRef.current.getElementsByClassName('appointment-form')
      const width = element[0]?.clientWidth
      setFormAppointmentWidth(width);

      handleAutoScrollAfterOpenForm()
    }
  }, [showForm, location.state]);

  const handleOpenAMApp = useCallback((status: boolean) => {
    setPopApp(!status)
  }, [])

  useEffect(() => {
    if (popAppRef?.current) {
      const element = popAppRef.current.getElementsByClassName('appointment-app')
      let width = element[0]?.clientWidth || 0
      if (!width && fromAppointmentRef.current) {
        const elementForm: any = fromAppointmentRef.current.getElementsByClassName('appointment-form')
        width = elementForm[0]?.clientWidth
      }
      setFormAppointmentWidth(width);
    }
  }, [popApp])

  const handleApp = useCallback((item: any) => {
    setPatientIdApp(item)

    if (viewDisplay === 'DATE' && item?.date) {
      const m = moment(item.date)
      setFilterDate({
        year: m.year() || moment().year(),
        month: m.month() + 1,
        date: m.date() || moment().date(),
        day: m.format('ddd')
      })
    }

    onEdit(item?.appointmentId, false, item?.doctorId)
  }, [viewDisplay, onEdit])

  const loadDataApp = useCallback(async () => {
    await AppointmentApi.waitingApprove({ branchId: filterBranch, status: 'WAITING_APPROVE' }).then((res) => {
      const newData = (res?.data || []).filter((item: any) => item.status !== 'DELETED')
      setDataAppAppointment(newData)
    })
  }, [filterBranch])

  return (
    <div className="h-100">
      <Loading show={loading} type="fullLoading" />
      <Card className="appointment border-0 h-100 overflow-hidden">
        <HeadAppointment
          branchId={filterBranch}
          viewDisplay={viewDisplay}
          date={filterDate}
          doctor={filterDoctor}
          handleViewDisplay={setViewDisplay}
          handleBranchId={setFilterBranch}
          handleDate={(val) => {
            setFilterDate(val)
          }}
          handlePatient={setFilterPatient}
          handleClickAdd={addAppointment}
          handleDoctor={setFilterDoctor}
          handleClickView={onViewHistory}
          statusShowForm={showForm}
          handleOpenAMApp={handleOpenAMApp}
          statusPopApp={popApp}
          countApp={dataAppAppointment?.length || 0}
          reRender={reRender}
          displayPages={displayPages}
          selectedPage={selectedPage}
          onSelectPage={setSelectedPage}
        />
        <Card.Body className={`px-1 pb-1 pt-0 overflow-hidden custom-scroll`} style={{ zIndex: 2, position: 'relative' }}>
          <Col className={`px-1 pb-1 pt-0 overflow-hidden custom-scroll`} style={{ height: '100%', width: `calc(100% - ${popApp ? formAppointmentWidth : 0}px)` }} >
            {(!loading && (
              <>
                {viewDisplay === 'DATE' ? (
                  (listAppointmentDay.length && (
                    <DisplayDay
                      branch={branch}
                      branchId={filterBranch}
                      timeRange={timeRange}
                      listAppointmentDay={filteredListAppointmentDay}
                      onEdit={(id: number) => onEdit(id, false, doctorId, '', filterBranch)}
                      onEditSpecialInfo={(id: number) => onEdit(id, true)}
                      clinicIsClose={clinicIsClose}
                      formAppointmentWidth={formAppointmentWidth}
                      onClickShare={handleClickShare}
                    />
                  )) || <DivNoneData>{t('APPOINTMENT.NONE_DATA')}</DivNoneData>
                ) : (
                  <></>
                )}
                {viewDisplay === 'WEEK' ? (
                  (listAppointmentWeek.length && (
                    <DisplayWeek
                      branch={branch}
                      branchId={filterBranch}
                      timeRange={timeRange}
                      listAppointment={listAppointmentWeek}
                      onEdit={(id: number) => onEdit(id, false, doctorId, '', filterBranch)}
                      onEditSpecialInfo={(id: number) => onEdit(id, true)}
                      clinicDayClose={clinicDayClose}
                      doctorWeek={doctorWeek}
                    />
                  )) || <DivNoneData>{t('APPOINTMENT.NONE_DATA')}</DivNoneData>
                ) : (
                  <></>
                )}
                {viewDisplay === 'MONTH' ? (
                  <DisplayMonth branch={branch} branchId={filterBranch} year={filterDate.year} month={filterDate.month} listAppointment={listAppointmentMonth} onEdit={(id: number) => onEdit(id, false, doctorId, '', filterBranch)} onEditSpecialInfo={(id: number) => onEdit(id, true)} />
                ) : (
                  <></>
                )}
                {viewDisplay === 'OVERALL' ? (
                  <DisplayOverall
                    branchId={filterBranch}
                    year={filterDate.year}
                    month={filterDate.month}
                    listAppointment={listAppointmentMonth}
                    onEdit={(id: number) => onEdit(id, false)}
                    onEditSpecialInfo={(id: number) => onEdit(id, true)}
                    timeRange={timeRange}
                    branch={branch}
                  />
                ) : (
                  <></>
                )}
              </>
            ))}
          </Col>
          <Col ref={fromAppointmentRef}>
            {!_.isEmpty(clinicInfo) && showForm && (

              <FormAppointment
                key={key}
                typeForm={'slice'}
                showForm={showForm}
                viewDisplay={viewDisplay}
                handleSuccess={(inputDate: any) => {
                  loadAppointment(inputDate)
                  setRerender(prev => !prev)
                }}
                reload={() => {
                  loadAppointment()
                  setRerender(prev => !prev)
                }}
                dataAppointment={viewDisplayData}
                date={viewDisplay === 'DATE' ? filterDate : ''}
                branchId={filterBranch}
                appointmentId={appointmentId}
                onReset={() => {
                  dispatch(resetModal())
                  setAppointmentId(undefined)
                  setShowForm(false)
                  setEditSpecialInfo(false)
                  setFormAppointmentWidth(0)
                  setPatientIdApp({})
                }}
                handleDate={(val) => {
                  setFilterDate(val)
                  if (val?.branchId) {
                    setFilterBranch(val.branchId)
                  }
                }}
                handleBranch={(val) => {
                  setFilterBranch(val)
                }}
                onDelete={onDelete}
                editSpecialInfo={editSpecialInfo}
                officeTime={clinicInfo.officeTimes}
                reRender={handleSetDataReRender}
                setRerender={(value) => setRerender(value)}
                reRenderValue={reRender}
                patientIdApp={patientIdApp}
                timeAppointment={clinicInfo?.timeAppointment}
                doctorId={doctorId}
              />
            )}
          </Col>
          <Col ref={popAppRef}>
            {popApp &&
              <AppointmentApp
                handleOpenAMApp={handleOpenAMApp}
                handleApp={handleApp}
                dataAppAppointment={dataAppAppointment}
              />
            }
          </Col>
        </Card.Body>

        {showListAppointment && <ViewHistory onClose={() => setShowListAppointment(false)} onEdit={(id: number, isEditSpecialInfo: boolean, date: string, branchId: number) => onEdit(id, isEditSpecialInfo, undefined, date, branchId)} />}
      </Card>
      {openShare &&
        <AppointmentScheduleShare
          data={dataShare}
          onClose={() => setOpenShare(false)}
          branch={branch}
          date={filterDate}
          timeRange={timeRange}
        />
      }
    </div>
  )
}

export const useFormatSizeAppointment = () => {
  const getStatus = () => {
    const secureStatus = getSecureItem(KEY_STORAGE.FORMATAPPOINTMENT)
    const rawStatus = secureStatus ?? localStorage?.getItem(KEY_STORAGE.FORMATAPPOINTMENT) ?? '0'
    return rawStatus === '0' ? 500 : 284
  }

  const [sizeSectionAppointment, setSizeSectionAppointment] = useState(getStatus);

  useEffect(() => {
    const handleStorageChange = () => {
      setSizeSectionAppointment(getStatus());
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return sizeSectionAppointment;
};
